<form [formGroup]="skjema" (ngSubmit)="slett()" novalidate>
  <h2 mat-dialog-title id="slett-med-aarsak-dialog-tittel">{{ parametre.tittel }}</h2>
  <mat-dialog-content>
    @if(parametre.innhold){
    <p>{{ parametre.innhold }}</p>
    }
    @if(parametre.htmlInnhold){
      <ng-container *ngTemplateOutlet="parametre.htmlInnhold ; context: parametre.htmlInnholdContext"/>
    }
    <mat-form-field>
      <mat-label>{{ 'Angi årsak'|translate }}</mat-label>
      <input matInput [formControl]="skjema.controls.aarsak">
      @if (skjema.controls.aarsak.hasError('maxlength')) {
        <mat-error data-testid="maxlength">{{ skjema.controls.aarsak.errors | standardvalideringsfeil:'maxlength' }}
        </mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" (click)="avbryt()" cdkFocusInitial class="avbryt">{{ parametre.avbrytKnapp }}</button>
    <button mat-raised-button type="submit" color="warn" [disabled]="skjema.invalid" class="ok">{{ parametre.okKnapp }}</button>
  </mat-dialog-actions>
</form>
